import React, { useEffect, useState } from "react";
import { FormField } from "@arp/react-ndbx";

import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

// import { useTheme } from "@mui/material/styles";
// import { makeStyles } from "tss-react/mui";

import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

//----------------------------------------------------------------

const RHFAutocompleteChip = React.forwardRef((props, ref) => (
	<FormField ref={ref} Component={RHFAutocompleteChipImp} {...props} />
));

const RHFAutocompleteChipImp = React.forwardRef(
	(
		{
			name = "undefined",
			defaultValue = [],
			variant = "outlined",
			dataValues,
			onFocus,
			disabled = false,
			multiple = true,
			label = "Select",
			placeholder = "Select",
			onBlur,
			clearValue,
			disableCloseOnSelect = false,
		},
		ref
	) => {
		const [value, setValue] = useState([]);
		const [clearComponent, setClearComponent] = useState(Math.random());
		const [selectedValues, setSelectedValues] = useState(defaultValue);
		const [isOpen, setIsOpen] = useState(false);

		const handleOpen = () => {
			setIsOpen(true);
		};

		const handleOnClose = () => {
			setIsOpen(false);
		};

		useEffect(() => {
			setValue([]);
			setClearComponent(Math.random());
			setIsOpen(false);
		}, [clearValue]);

		//* We only want to call update conditions when we click on
		//* an L or E, not when the page is loading.
		const [updateOnChange, setUpdateOnChange] = useState(false);

		const handleOnChange = (newValue) => {
			setValue(multiple ? [...newValue] : [newValue]);
			setUpdateOnChange(true);
		};

		useEffect(() => {
			if (updateOnChange === false) return;
			onBlur(value);
			if (value?.length <= 0 || value === "") {
				setIsOpen(false);
			}
			setUpdateOnChange(false);
		}, [value]);

		return (
			<FormControl sx={{ width: "100%", outline: "0px solid red" }}>
				<Autocomplete
					multiple={multiple}
					id={`${name}-autocomplete`}
					name={name}
					fullWidth
					freeSolo={false}
					open={isOpen}
					onOpen={handleOpen}
					onClose={handleOnClose}
					clearOnEscape
					disabled={disabled}
					disableCloseOnSelect={disableCloseOnSelect}
					defaultValue={
						selectedValues || clearValue === true ? selectedValues : []
					}
					onFocus={onFocus}
					onChange={(event, newValue) => {
						handleOnChange(multiple ? [...newValue] : [newValue]);
					}}
					// onBlur={handleOnBlur}
					options={dataValues}
					getOptionLabel={(option) =>
						option?.display != null ? option.display : ""
					}
					renderTags={(tagValue, getTagProps) =>
						tagValue.map((option, index) => (
							<Chip
								label={option.name}
								{...getTagProps({ index })}
								variant={variant}
								style={{ marginLeft: 0 }}
							/>
						))
					}
					renderOption={(props, option, { selected }) => (
						<li {...props}>
							{multiple ? (
								<Checkbox
									icon={icon}
									checkedIcon={checkedIcon}
									style={{ marginRight: 8 }}
									checked={selected}
								/>
							) : null}
							{option.display}
						</li>
					)}
					renderInput={(params) => (
						<TextField
							{...params}
							label={label}
							placeholder={placeholder}
							variant="standard"
							inputRef={ref}
							freeSolo={false}
						/>
					)}
					key={clearComponent}
				/>
			</FormControl>
		);
	}
);

export default RHFAutocompleteChip;
